export const STORAGE_SERVICE_TOKEN = Symbol('STORAGE_SERVICE_TOKEN');

export interface IStorageService {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  hasItem(key: string): boolean;
  removeItem(key: string): void;
  clear(): void;
}
